export const COMMON = {
  //TOGGLE_LOADING: 'COMMON.TOGGLE_LOADING',
  //GET_WALLETS_BY_EMAIL_SUCCESS: 'COMMON.GET_WALLETS_BY_EMAIL_SUCCESS',
  //GET_WALLETS_BY_EMAIL_FAILED: 'COMMON.GET_WALLETS_BY_EMAIL_FAILED',
  //ON_NEW_TX_ADDED: 'COMMON.ON_NEW_TX_ADDED',
};

export const USERS = {
  TOGGLE_LOGIN_MODAL: 'USERS.TOGGLE_LOGIN_MODAL',
  //SIGNUP_SUCCESS: 'USERS.SIGNUP_SUCCESS',
  //SIGNUP_FAILED: 'USERS.SIGNUP_FAILED',
  LOGIN_SUCCESS: 'USERS.LOGIN_SUCCESS',
  LOGIN_FAILED: 'USERS.LOGIN_FAILED',
  LOGOUT: 'USERS.LOGOUT',
};

export const PROGRAMS = {
	GET_PROGRAMS_SUCCESS: 'PROGRAMS.GET_PROGRAMS_SUCCESS',
};
